import React from 'react';
import { string } from 'prop-types';

const DownTriangle = ({ color = 'bg6-color', fontSize = '11px', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_market_down ${className}`}
  />
);

DownTriangle.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default DownTriangle;
